<div class="modal-wrapper sm:max-w-md md:max-w-xl">

    <div class="flex items-center border-b-[0.5px] pb-3 border-[#DAE1E4]">
        <h3 class="modal-title">
            {{'Your statement' | translate}}</h3>
        <!-- Cancel Icon -->
        <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0!" (click)="close()" />
    </div>

    <div class="flex justify-between gap-3 my-6! font-medium text-base">
        <p class="text-(--text-muted)">Statement period</p>
        <p class="text-(--text-primary)">Jan - July</p>
    </div>

    <div class="w-full h-60 flex justify-center items-center bg-white text-medium">
        Placeholder statement
    </div>

    <!-- Continue Button -->
    <app-button [text]="'Download in PDF' | translate" type="button" variant="primary" size="lg"
        extraClass="mt-10" (action)="onDownload()"></app-button>

</div>